import type { FormStep } from "./form-types";
import type { ContentAlignment } from "./LeadFormStep";

export type { FormStep } from "./form-types";

export function toContentAlignment(step: FormStep): ContentAlignment {
  if (step.contentAlignment === "custom") {
    return {
      desktop: step.contentAlignmentDesktop ?? undefined,
      mobile: step.contentAlignmentMobile ?? "left",
      tablet: step.contentAlignmentTablet ?? undefined,
    };
  }
  return step.contentAlignment ?? "left";
}
